const processingLabel = document.body?.dataset.authProcessingLabel || 'Processing';

const initPasswordToggles = () => {
    document.querySelectorAll('[data-password-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
            const field = document.getElementById(button.dataset.passwordToggle);

            if (!field) {
                return;
            }

            const nextType = field.type === 'password' ? 'text' : 'password';
            field.type = nextType;
            button.setAttribute('aria-pressed', String(nextType === 'text'));

            button.querySelectorAll('[data-password-icon]').forEach((icon) => {
                icon.hidden = icon.dataset.passwordIcon !== nextType;
            });
        });
    });
};

const initSubmitState = () => {
    document.querySelectorAll('.auth-shell form').forEach((form) => {
        form.addEventListener('submit', () => {
            const button = form.querySelector('button[type="submit"], button:not([type]), input[type="submit"]');

            if (!button || button.disabled) {
                return;
            }

            const label = button.dataset.loadingLabel || button.textContent?.trim() || processingLabel;

            button.classList.add('is-loading');
            button.setAttribute('aria-busy', 'true');

            if (button.tagName === 'BUTTON') {
                button.innerHTML = `
                    <span class="auth-submit__spinner" aria-hidden="true"></span>
                    <span>${label}...</span>
                `;
            } else {
                button.value = `${label}...`;
            }

            setTimeout(() => {
                button.disabled = true;
            }, 0);
        }, { once: true });
    });
};

initPasswordToggles();
initSubmitState();
